import { type QueryKey, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

/**
 * Fetches the query once more when the chat's turn ends. A turn can raise a
 * request after the last poll and end before the next one, and the agent
 * only learns the answer in a later turn, so the request must be found now.
 */
export const useRefetchWhenTurnEnds = (
  queryKey: QueryKey,
  chatBusy: boolean
) => {
  const client = useQueryClient();
  const wasBusy = useRef(chatBusy);
  useEffect(() => {
    if (wasBusy.current && !chatBusy) {
      // A poll that left before the turn ended may carry an older answer, and
      // invalidation alone reuses a first poll instead of replacing it
      void client
        .cancelQueries({ queryKey })
        .then(() => client.invalidateQueries({ queryKey }));
    }
    wasBusy.current = chatBusy;
  }, [chatBusy, client, queryKey]);
};
